import { useEffect } from 'react'
import { animateScroll } from 'react-scroll'

export const useAnimatedScroll = (options = {}) => {
  useEffect(() => {
    animateScroll.scrollToTop(options)
  }, [])
}
